// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"b272ed72","221":"a8f4a598","453":"c7001196","481":"a2e65934","505":"3f069992","520":"5feccf74","718":"769c027a","861":"5fc65b05","866":"874e64e7","871":"7b2005ae"}[chunkId] + ".chunk.js";
};